import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { Grid, Card, CardHeader, Typography, Divider, CardContent, FormControl, InputLabel, MenuItem, Select, TextField, Button, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Paper, CircularProgress, Chip, Box } from '@mui/material';

import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import DownloadIcon from '@mui/icons-material/Download';
import UndoIcon from '@mui/icons-material/Undo';

import moment from 'moment';
import 'moment/locale/es-mx';

import { DownloadFile } from '../../helpers/DownloadFile';
import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { usePages } from '../../hooks/usePages';

import { RootState } from '../../store';
import { openSnackbar } from '../../store/slices/SnackbarSlice';

import { TableTheadStyle, TablePaddingStyle } from '../../styles/TableStyle';

import { Layout } from '../../components/Layout';

import { DialogAmparo } from '../../dialogs/DialogAmparo';
import { DialogDocumento } from '../../dialogs/DialogDocumento';
import { DialogExpediente } from '../../dialogs/DialogExpediente';
import { DialogExhortoRecibido } from '../../dialogs/DialogExhortoRecibido';

import { ObtenerMateria } from '../../connections/catalogos/MateriaConnection';
import { ObtenerEstatus } from '../../connections/catalogos/EstatusConnection';
import { BuscarUsuariosNotificacion } from '../../connections/admin/UsuarioConnection';
import { ObtenerTipoAcuerdo } from '../../connections/catalogos/TipoAcuerdoConnection';
import { ObtenerSubTipoAcuerdo } from '../../connections/catalogos/SubTipoAcuerdoConnection';
import { ObtenerAutoridadesMaterias } from '../../connections/catalogos/AutoridadConnection';
import { ObtenerTipoNotificacion } from '../../connections/catalogos/TipoNotificacionConnection';
import { ConsultarNotificaciones, DescargarNotificaciones } from '../../connections/notificaciones/NotificacionConnection';

import { MateriaProps } from '../../interfaces/catalogos/MateriaInterface';
import { EstatusProps } from '../../interfaces/catalogos/EstatusInterface';
import { AutoridadProps } from '../../interfaces/catalogos/AutoridadInterface';
import { UsuarioNotificacionProps } from '../../interfaces/admin/UsuarioInterface';
import { TipoAcuerdoProps } from '../../interfaces/catalogos/TipoAcuerdoInterface';
import { defaultAmparo, AmparoProps } from '../../interfaces/recepcion/AmparoInterface';
import { SubTipoAcuerdoProps } from '../../interfaces/catalogos/SubTipoAcuerdoInterface';
import { TipoNotificacionProps } from '../../interfaces/catalogos/TipoNotificacionInterface';
import { defaultExpediente, ExpedienteProps } from '../../interfaces/recepcion/ExpedienteInterface';
import { defaultExhortoRecibido, ExhortoRecibidoProps } from '../../interfaces/recepcion/ExhortoRecibidoInterface';
import { DescargarNotificacionesParams, NotificacionConsultaProps } from '../../interfaces/notificaciones/NotificacionesInterface';

export const NotificacionesPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [loading, setLoading] = useState( false );
    const [loadingSearch, setLoadingSearch] = useState( false );
    const [loadingDescargar, setLoadingDescargar] = useState( false );

    const [recordCount, setRecordCount] = useState( 0 );

    const [rows, setRows] = useState<NotificacionConsultaProps[]>( [] );

    const [materia, setMateria] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );

    const [usuario, setUsuario] = useState( 0 );
    const [usuarioArray, setUsuarioArray] = useState<UsuarioNotificacionProps[]>( [] );

    const [tipoNotificacion, setTipoNotificacion] = useState( 0 );
    const [tipoNotificacionArray, setTipoNotificacionArray] = useState<TipoNotificacionProps[]>( [] );

    const [estatus, setEstatus] = useState( 0 );
    const [estatusArray, setEstatusArray] = useState<EstatusProps[]>( [] );

    const [tipoAcuerdo, setTipoAcuerdo] = useState( 0 );
    const [tipoAcuerdoArray, setTipoAcuerdoArray] = useState<TipoAcuerdoProps[]>( [] );

    const [subTipoAcuerdo, setSubTipoAcuerdo] = useState( 0 );
    const [subTipoAcuerdoArray, setSubTipoAcuerdoArray] = useState<SubTipoAcuerdoProps[]>( [] );

    const [fecha, setFecha] = useState( '' );
    const [numeroReferencia, setNumeroReferencia] = useState( '' );

    const [filtroAplicado, setFiltroAplicado] = useState( false );

    const [openDocument, setOpenDocument] = useState( false );
    const [doc, setDoc] = useState( '' );

    const [openDialogExpediente, setOpenDialogExpediente] = useState( false );
    const [expedienteSeleccionado, setExpedienteSeleccionado] = useState<ExpedienteProps>( defaultExpediente );

    const [openDialogAmparo, setOpenDialogAmparo] = useState( false );
    const [amparoSeleccionado, setAmparoSeleccionado] = useState<AmparoProps>( defaultAmparo );

    const [openDialogExhortoRecibido, setOpenDialogExhortoRecibido] = useState( false );
    const [exhortoRecibidoSeleccionado, setExhortoRecibidoSeleccionado] = useState<ExhortoRecibidoProps>( defaultExhortoRecibido );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 10 );

    const handleClearFiltro = () => {

        setFiltroAplicado( false );

        setMateria( 0 );
        setAutoridad( 0 );
        setFecha( '' );
        setUsuario( 0 );
        setTipoNotificacion( 0 );
        setEstatus( 0 );
        setTipoAcuerdo( 0 );
        setSubTipoAcuerdo( 0 );
        setNumeroReferencia( '' );

        setRows( [] );
        setRecordCount( 0 );

        resetPage();

    }

    const handleBuscar = async () => {

        setLoadingSearch( true );
        setFiltroAplicado( true );

        setRecordCount( 0 );
        resetPage();

    }

    const handleVerDetalle = ( { amparo, exhortoRecibido, expediente }: NotificacionConsultaProps ) => {

        if ( amparo.idAmparo !== 0 ) {

            setAmparoSeleccionado( amparo );
            setOpenDialogAmparo( true );

        }
        else if ( exhortoRecibido.idExhortoRecibido !== 0 ) {

            setExhortoRecibidoSeleccionado( exhortoRecibido );
            setOpenDialogExhortoRecibido( true );

        }
        else {

            setExpedienteSeleccionado( expediente );
            setOpenDialogExpediente( true );

        }

    }

    const handleDescargarInformacion = async () => {

        setLoadingDescargar( true );

        const params: DescargarNotificacionesParams = {
            idUsuario: usuario,
            idTipoNotificacion: tipoNotificacion,
            idAutoridad: autoridad,
            idMateria: materia,
            idEstatus: estatus,
            idTipoAcuerdo: tipoAcuerdo,
            idSubTipoAcuerdo: subTipoAcuerdo,
            numeroReferencia: numeroReferencia,
            fecha: fecha ? moment( fecha ).format( 'YYYY-MM-DD' ) : '',
        };

        await DescargarNotificaciones( params ).then( resp => {

            setTimeout(() => {

                if ( resp ) {

                    DownloadFile( `Notificaciones-${ Date.now() }.xlsx`, resp );
                    setLoadingDescargar( false );

                }
                else {

                    dispatch( openSnackbar({ message: 'Ocurrio un error contacte con el administrador', variant: 'error' }) );
                    setLoadingDescargar( false );

                }

            }, 700);

        });

    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerMateria().then( resp => {
                setMateriaArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoNotificacion().then( resp => {
                setTipoNotificacionArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await ObtenerEstatus().then( resp => {
                setEstatusArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoAcuerdo().then( resp => {
                setTipoAcuerdoArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await BuscarUsuariosNotificacion().then( resp => {
                setUsuarioArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setAutoridad( 0 );
            setAutoridadArray( [] );

            if ( materia !== 0 ) {

                await ObtenerAutoridadesMaterias( materia ).then( resp => {
                    setAutoridadArray( resp );
                });

            }

        }

        Obtener();

    }, [ materia ]);

    useEffect(() => {

        async function Obtener() {

            setSubTipoAcuerdo( 0 );
            setSubTipoAcuerdoArray( [] );

            if ( tipoAcuerdo !== 0 ) {

                await ObtenerSubTipoAcuerdo( tipoAcuerdo ).then( resp => {
                    setSubTipoAcuerdoArray( resp );
                });

            }

        }

        Obtener();

    }, [ tipoAcuerdo ]);

    useEffect(() => {

        async function Obtener() {

            setLoading( true );
            setRows( [] );

            await ConsultarNotificaciones({ page, rowsPerPage, idMateria: 0, idUsuario: 0, idAutoridad: 0, numeroReferencia: '', idTipoNotificacion: 0, idEstatus: 0, idTipoAcuerdo: 0, idSubTipoAcuerdo: 0, fecha: '' }).then( resp => {

                setTimeout(() => {

                    setRecordCount( resp.recordsCount );
                    setRows( resp.records );

                    setLoadingSearch( false );
                    setLoading( false );

                }, 700);

            });

        }

        if ( !filtroAplicado ) {
            Obtener();
        }

    }, [ page, rowsPerPage, filtroAplicado ]);

    useEffect(() => {

        async function Obtener() {

            setLoading( true );
            setRows( [] );

            await ConsultarNotificaciones({
                page,
                rowsPerPage,
                idMateria: materia,
                idUsuario: usuario,
                idAutoridad: autoridad,
                numeroReferencia,
                idTipoNotificacion: tipoNotificacion,
                idEstatus: estatus,
                idTipoAcuerdo: tipoAcuerdo,
                idSubTipoAcuerdo: subTipoAcuerdo,
                fecha: fecha ? moment( fecha ).format( 'YYYY-MM-DD' ) : '',
            }).then( resp => {

                setTimeout(() => {

                    setRecordCount( resp.recordsCount );
                    setRows( resp.records );

                    setLoadingSearch( false );
                    setLoading( false );

                }, 700);

            });

        }

        if ( filtroAplicado ) {
            Obtener();
        }

    }, [ page, rowsPerPage, filtroAplicado, materia, autoridad, fecha, usuario, tipoNotificacion, estatus, tipoAcuerdo, subTipoAcuerdo, numeroReferencia ]);

    return (
        <Layout breadcrumbs={ [{ text: 'Consultas' }, { text: 'Notificaciones' }] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                {
                    ( administrador || coordinador )
                    &&
                        <Grid size={{ md: 12, xs: 12 }} textAlign={ 'start' }>

                            <Button startIcon={ <UndoIcon /> } color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate('/') }>
                                Regresar
                            </Button>

                        </Grid>
                }

                <Grid size={{ md: 12, xs: 12 }}>

                    <Card>
                        <CardHeader
                            sx={{ backgroundColor: (theme) => theme.palette.primary.main, py: 2 }}
                            subheader={<Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Filtro(s) </Typography>}
                        />

                        <Divider />

                        <CardContent sx={{ p: 3 }}>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ md: 2, xs: 12 }}>

                                    <FormControl fullWidth>
                                        <InputLabel>Materia</InputLabel>

                                        <Select
                                            label='Materia'
                                            value={ materia }
                                            disabled={ filtroAplicado }
                                            onChange={ (e) => setMateria( e.target.value ) }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                materiaArray
                                                .filter( ({ idMateria }) => idMateria === 5 || idMateria === 6 )
                                                .map( ({ idMateria, descripcion }) => (
                                                    <MenuItem key={ idMateria } value={ idMateria }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 4, xs: 12 }}>

                                    <FormControl fullWidth>
                                        <InputLabel>Autoridad</InputLabel>

                                        <Select
                                            label='Autoridad'
                                            value={ autoridad }
                                            disabled={ filtroAplicado || materia === 0 }
                                            onChange={ (e) => setAutoridad( e.target.value ) }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                autoridadArray.map( ({ idAutoridad, descripcion }) => (
                                                    <MenuItem key={ idAutoridad } value={ idAutoridad }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>

                                    <TextField
                                        fullWidth
                                        label='Número de referencia'
                                        placeholder='0/0000'
                                        autoComplete='off'
                                        variant='outlined'
                                        value={ numeroReferencia }
                                        onChange={ (e) => setNumeroReferencia( e.target.value ) }
                                        disabled={ filtroAplicado }
                                        slotProps={{
                                            inputLabel: { shrink: true },
                                            input: { autoComplete: 'off' },
                                        }}
                                    />

                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>

                                    <LocalizationProvider dateAdapter={ AdapterMoment } adapterLocale='es'>
                                        <DatePicker
                                            label='Fecha de ordenamiento'
                                            sx={{ width: '100%' }}
                                            value={ fecha ? moment( fecha ) : null }
                                            maxDate={ moment( new Date() ) }
                                            onChange={ (newValue) => setFecha( newValue ? newValue.format( 'YYYY-MM-DD' ) : '' ) }
                                            disabled={ filtroAplicado }
                                            slotProps={{ textField: { InputLabelProps: { shrink: true } } }}
                                        />
                                    </LocalizationProvider>

                                </Grid>

                                <Grid size={{ md: 4, xs: 12 }}>

                                    <FormControl fullWidth>
                                        <InputLabel>Actuario(s)</InputLabel>

                                        <Select
                                            label='Actuario(s)'
                                            value={ usuario }
                                            onChange={ (e) => setUsuario( e.target.value ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                usuarioArray.map( ({ id, nombreCompleto }) => (
                                                    <MenuItem key={ id } value={ id }>{ nombreCompleto }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>

                                    <FormControl fullWidth>
                                        <InputLabel>Estatus</InputLabel>

                                        <Select
                                            label='Estatus'
                                            value={ estatus }
                                            disabled={ filtroAplicado }
                                            onChange={ (e) => setEstatus( e.target.value ) }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                estatusArray
                                                .filter( ({ idEstatus }) => [ 3, 28, 29, 54 ].includes( idEstatus ) )
                                                .map( ({ idEstatus, descripcion }) => (
                                                    <MenuItem key={ idEstatus } value={ idEstatus }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 5, xs: 12 }}>

                                    <FormControl fullWidth>
                                        <InputLabel>Tipo de notificación</InputLabel>

                                        <Select
                                            label='Tipo de notificación'
                                            value={ tipoNotificacion }
                                            disabled={ filtroAplicado }
                                            onChange={ (e) => setTipoNotificacion( e.target.value ) }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                tipoNotificacionArray.map( ({ idTipoNotificacion, descripcion }) => (
                                                    <MenuItem key={ idTipoNotificacion } value={ idTipoNotificacion }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 5, xs: 12 }}>

                                    <FormControl fullWidth>
                                        <InputLabel>Tipo de acuerdo</InputLabel>

                                        <Select
                                            label='Tipo de acuerdo'
                                            value={ tipoAcuerdo }
                                            disabled={ filtroAplicado }
                                            onChange={ (e) => setTipoAcuerdo( e.target.value ) }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                tipoAcuerdoArray
                                                .filter( ({ idTipoAcuerdo }) => ![ 19, 20 ].includes( idTipoAcuerdo ) )
                                                .map( ({ idTipoAcuerdo, descripcion }) => (
                                                    <MenuItem key={ idTipoAcuerdo } value={ idTipoAcuerdo }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 5, xs: 12 }}>

                                    <FormControl fullWidth>
                                        <InputLabel>Subtipo de acuerdo</InputLabel>

                                        <Select
                                            label='Subtipo de acuerdo'
                                            value={ subTipoAcuerdo }
                                            disabled={ filtroAplicado || tipoAcuerdo === 0 || subTipoAcuerdoArray.length === 0 }
                                            onChange={ (e) => setSubTipoAcuerdo( e.target.value ) }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                subTipoAcuerdoArray.map( ({ idSubTipoAcuerdo, descripcion }) => (
                                                    <MenuItem key={ idSubTipoAcuerdo } value={ idSubTipoAcuerdo }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 2, xs: 12 }}>

                                    <Button
                                        fullWidth
                                        variant={ filtroAplicado ? 'outlined' : 'contained' }
                                        color={ filtroAplicado ? 'secondary' : 'primary' }
                                        startIcon={ filtroAplicado ? <ClearIcon /> : <SearchIcon /> }
                                        onClick={ () => { filtroAplicado ? handleClearFiltro() : handleBuscar() } }
                                        loading={ loadingSearch }
                                        disabled={ materia === 0 && autoridad === 0 && !fecha && usuario === 0 && tipoNotificacion === 0 && estatus === 0 && tipoAcuerdo === 0 && subTipoAcuerdo === 0 && !numeroReferencia }
                                        sx={{ mt: 1, px: 5 }}
                                    >
                                        { filtroAplicado ? 'Limpiar filtro' : 'Buscar' }
                                    </Button>

                                </Grid>

                            </Grid>

                        </CardContent>

                    </Card>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }} textAlign={ 'end' }>

                    <Button
                        color='secondary'
                        variant='outlined'
                        startIcon={ <DownloadIcon /> }
                        onClick={ handleDescargarInformacion }
                        loading={ loadingDescargar }
                        disabled={ rows.length === 0 }
                    >
                        Descargar información
                    </Button>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }}>

                    <TableContainer sx={{ borderRadius: 3 }} component={ Paper }>

                        <Table sx={{ minHeight: rows.length === 0 ? 450 : 0 }}>

                            <TableHead sx={{ ...TableTheadStyle }}>

                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}></TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold', textAlign: 'center' }}>Fecha <br /> ordenamiento</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Referencia</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '30%', fontWeight: 'bold', textAlign: 'center' }}>Persona a notificar</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Estatus</TableCell>

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    rows.map( ( row, index ) => {

                                        const { numeroSeguimiento, numeroBoleta, fechaOrdenamiento, referencia, personaNotificar, domicilioNotificar, documento, tipoParte, tipoNotificacion, formaNotificacion, idEstatus, estatus, usuarioAsignado } = row;

                                        return (
                                        <TableRow key={ index }>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                {
                                                    documento
                                                    ?
                                                        <Button
                                                            fullWidth
                                                            variant='contained'
                                                            onClick={ () => { setDoc( documento ); setOpenDocument( true ); } }
                                                        >
                                                            { numeroSeguimiento }
                                                        </Button>
                                                    :
                                                        <Typography variant='subtitle1'>
                                                            <strong>{ numeroSeguimiento }</strong>
                                                        </Typography>
                                                }

                                                {
                                                    numeroBoleta
                                                    &&
                                                        <Typography variant='subtitle1' mt={ 1 }>
                                                            { numeroBoleta }
                                                        </Typography>
                                                }

                                                <Typography variant='subtitle1' mt={ 1 }>
                                                    { tipoNotificacion }
                                                </Typography>

                                                {
                                                    formaNotificacion
                                                    &&
                                                        <Typography variant='caption' color='text.secondary'>
                                                            ({ formaNotificacion })
                                                        </Typography>
                                                }

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                {
                                                    fechaOrdenamiento
                                                    &&
                                                        <>

                                                            <Typography variant='subtitle1'>
                                                                { moment( fechaOrdenamiento ).format( 'DD-MM-YYYY' ) }
                                                            </Typography>

                                                            <Typography variant='caption' color='text.secondary'>
                                                                { moment( fechaOrdenamiento ).format( 'hh:mm a' ) }
                                                            </Typography>

                                                        </>
                                                }

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Button
                                                    fullWidth
                                                    variant='contained'
                                                    onClick={ () => handleVerDetalle( row ) }
                                                >
                                                    { referencia }
                                                </Button>

                                            </TableCell>

                                            <TableCell>

                                                <Typography variant='subtitle1'>
                                                    <strong>{ personaNotificar.toUpperCase() }</strong> { tipoParte ? `(${ tipoParte })` : '' }
                                                </Typography>

                                                <Typography variant='subtitle2' color='text.secondary' fontWeight={ 'normal' } fontSize={ 12 }>{ domicilioNotificar }</Typography>

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Chip
                                                    variant='filled'
                                                    sx={{ fontWeight: 'bold', mb: 1 }}
                                                    color={ idEstatus === 3 ? 'primary' : 'default' }
                                                    label={
                                                        <Typography variant='subtitle1' fontWeight={ '600' } fontSize={ 13 }>
                                                            { estatus }
                                                        </Typography>
                                                    }
                                                />

                                                {
                                                    usuarioAsignado
                                                    &&
                                                        <Box sx={{ mt: 0.5 }}>

                                                            <Typography variant='caption' sx={{ fontWeight: 'bold', display: 'block', color: 'text.secondary' }}>
                                                                Asignado a:
                                                            </Typography>

                                                            <Typography variant='caption' sx={{ display: 'block', color: 'text.secondary', textTransform: 'uppercase', fontSize: 11 }}>
                                                                { usuarioAsignado }
                                                            </Typography>

                                                        </Box>
                                                }

                                            </TableCell>

                                        </TableRow>
                                    )})
                                }

                                {
                                    ( rows.length === 0 && !loading )
                                    ?
                                        <TableRow style={{ height: 73 }}>

                                            <TableCell colSpan={ 5 } align='center'>

                                                <Typography variant='caption' color='secondary'>
                                                    No se encontraron resultados
                                                </Typography>

                                            </TableCell>

                                        </TableRow>
                                    :
                                        loading
                                        &&
                                            <TableRow style={{ height: 73 }}>

                                                <TableCell colSpan={ 5 } align='center'>

                                                    <CircularProgress size={ 32 } />

                                                </TableCell>

                                            </TableRow>
                                }

                            </TableBody>

                            <TableFooter>

                                <TableRow>

                                    <TableCell colSpan={ 2 }>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: { recordCount } </Typography>
                                    </TableCell>

                                    <TablePagination
                                        colSpan={ 3 }
                                        rowsPerPageOptions={ [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ] }
                                        count={ recordCount }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }
                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }
                                        ActionsComponent={ TablePaginationActions }
                                        labelRowsPerPage='Filas por página'
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                                return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />

                                </TableRow>

                            </TableFooter>

                        </Table>

                    </TableContainer>

                </Grid>

            </Grid>

            <DialogDocumento
                documento={ doc }
                openDialog={ openDocument }
                handleCloseDialog={ () => { setOpenDocument( false ); setDoc( '' ); } }
            />

            <DialogExpediente
                expediente={ expedienteSeleccionado }
                openDialog={ openDialogExpediente }
                handleCloseDialog={ () => setOpenDialogExpediente( false ) }
            />

            <DialogAmparo
                amparo={ amparoSeleccionado }
                openDialog={ openDialogAmparo }
                handleCloseDialog={ () => setOpenDialogAmparo( false ) }
            />

            <DialogExhortoRecibido
                exhortoRecibido={ exhortoRecibidoSeleccionado }
                openDialog={ openDialogExhortoRecibido }
                handleCloseDialog={ () => setOpenDialogExhortoRecibido( false ) }
            />

        </Layout>
    )
}
